import React, { useEffect, useRef, useState } from 'react';
import css from './Counter.module.scss';

const CounterProduct = ({ getHandlers, val, handlers, tbody, rowIndex }) => {
    const inputRef = useRef();
    const [inputValueChangeQuickMoment, setInputValueChangeQuickMoment] = useState(val);
    useEffect(() => {
        if (inputRef.current) {
            const val = +inputValueChangeQuickMoment || +inputRef.current.value || 1;
            // ставимо ширину поля від ширини контента
            const newInputWidth = String(val)?.length * 1.4 + 'ch';
            inputRef.current.style.width = newInputWidth;
            inputRef.current.style.minWidth = '1.4ch';
        }
    }, [inputRef.current, inputValueChangeQuickMoment]);
    return (
        <div className={css.wrapper}>
            <div className={css.counter}>
                <div {...getHandlers('minus')} className={css.counterBtn}>
                    -
                </div>
                <input
                    ref={inputRef}
                    className={css.counterInput}
                    type={'number'}
                    value={val}
                    onBlur={(e) => {
                        if (typeof handlers?.quantity?.inputValue?.change === 'function') {
                            handlers?.quantity?.inputValue?.change(tbody?.[rowIndex], e.target.value);
                            setInputValueChangeQuickMoment(e.target.value);
                        }
                    }}
                    onChange={(e) => {
                        if (typeof handlers?.quantity?.inputValue?.changeNew === 'function') {
                            handlers?.quantity?.inputValue?.changeNew(tbody?.[rowIndex], e.target.value);
                            setInputValueChangeQuickMoment(e.target.value);
                        }
                    }}
                ></input>
                <div {...getHandlers('plus')} className={css.counterBtn}>
                    +
                </div>
            </div>
        </div>
    );
};
export default CounterProduct;
